@if (facetConfigurations.length > 1) {
  <mat-tab-group (selectedIndexChange)="setSelectedTabIndex($event)" [selectedIndex]="selectedTabIndex$ | async"
                 class="h-full bg-white">
    @for (item of facetConfigurations; track item.type) {
      <mat-tab [label]="'catalog.facet_'+item.type+'.title' | transloco">
        <ng-template matTabContent>
          <ng-container *ngTemplateOutlet="tpl; context: {item: item}"></ng-container>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
} @else if (facetConfigurations.length === 1) {
  <div class="md:h-full bg-white">
    <ng-container *ngTemplateOutlet="tpl; context: {item: facetConfigurations[0]}"></ng-container>
  </div>
}

<ng-template #tpl let-item="item">
  @switch (item.type) {
    @case ('map') {
      <cat-facet-map class="md:h-full" [facetItem]="selectFacetItem() | async"
                     [searchItem]="searchItem"></cat-facet-map>
    }
    @case ('list') {
      <cat-facet-list [facetItem]="selectFacetItem() | async" [searchItem]="searchItem"
                      class="md:h-full"></cat-facet-list>
    }
    @case ('tree') {
      <cat-facet-tree [facetItem]="selectFacetItem() | async" [searchItem]="searchItem"
                      class="md:h-full" [settings]="getTreeSettings(item)"></cat-facet-tree>
    }
    @case ('timeline') {
      <cat-facet-timeline [facetItem]="selectFacetItem() | async" [settings]="getTimelineSettings(item)"
                          [searchItem]="searchItem"
                          class="md:h-full"></cat-facet-timeline>
    }
    @case ('statistics') {
      <cat-facet-statistics [facetItem]="selectFacetItem() | async"
                            [searchItem]="searchItem"
                            class="md:h-full"></cat-facet-statistics>
    }
  }
</ng-template>
